import React from 'react';
import { Box, Card, Typography } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import { useTranslation } from 'react-i18next';

export default function ContactInfoCard() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        mt: { xs: 4, sm: -24 },
        mb: 5,
        position: 'relative',
        zIndex: 10,
        height: 350,
      }}
    >
      <Card
        sx={{
          width: 320,
          height: 320,
          borderRadius: '50%',
          boxShadow: 6,
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around',
          alignItems: 'center',
          textAlign: 'center',
          backgroundColor: '#fff',
          borderTop: `10px solid #CE8238`,
          borderLeft: `10px solid #0057A4`,
          borderBottom: `10px solid #CE8238`,
          borderRight: `10px solid #0057A4`,
        }}
      >
        {/* Top: Opening Hours */}
        <Box>
          <Typography variant="subtitle2" color="error" fontWeight="bold">
            {t('opening_hours.title')}
          </Typography>
          <Typography variant="h6" fontWeight="bold">
            {t('opening_hours.service')}
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.5 }}>
            <span style={{ color: '#CE8238', fontWeight: 600 }}>
              {t('opening_hours.time')}
            </span>
          </Typography>
        </Box>

        {/* Middle: Logo */}
        <Box
          component="img"
          src="/image/Logo.png"
          alt="Logo"
          sx={{
            width: 100,
            height: 100,
            borderRadius: '50%',
            borderTop: `2px solid #CE8238`,
            borderLeft: `2px solid #0057A4`,
            borderBottom: `2px solid #CE8238`,
            borderRight: `2px solid #0057A4`,
            objectFit: 'contain',
            backgroundColor: '#f9f9f9',
          }}
        />

        {/* Bottom: Phone */}
        <Box>
          <Typography variant="subtitle2" sx={{ color: '#CE8238', fontWeight: 'bold' }}>
            {t('opening_hours.unified')}
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
            }}
          >
            <PhoneIcon fontSize="small" sx={{ color: 'green' }} />
            +96614887491
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 220 }}>
            {t('opening_hours.message')}
          </Typography>
        </Box>
      </Card>
    </Box>
  );
}
